const NEW_READINGS = 'READING_EVENT';
const ACTIVE_ALARM_CHANGE = ['ALARM_TRIGGERED_EVENT', 'ALARM_CLEARED_EVENT'];
const ALARM_DELETED_EVENT = 'ALARM_DELETED_EVENT';

export { NEW_READINGS, ACTIVE_ALARM_CHANGE, ALARM_DELETED_EVENT };
